import api from "./api";

export const sendBusinessVerificationOtp = async (): Promise<{ message: string }> => {
  const response = await api.post<{ message: string }>("/admin/business/send-otp");
  return response.data;
};

export const verifyBusinessClaimOtp = async (otp: string): Promise<{ message: string }> => {
  const response = await api.post<{ message: string }>("/admin/business/verify-otp", { otp });
  return response.data;
};
